import { PaymentType } from '../enums/payment-type.enum';

export class PaymentDto {
  public id: number;
  public name: string;
  public receipts: number[];
  //TODO: does it work if on the API it is a string?
  public paymentType: PaymentType;
  public currency: number;
}
